"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var React = _interopRequireWildcard(require("react"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function SvgComponent(props, svgRef) {
  return (0, _jsxRuntime.jsx)("svg", _objectSpread(_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 2489.2 2487.6",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), {}, {
    children: (0, _jsxRuntime.jsxs)("g", {
      fill: "#333",
      fillRule: "evenodd",
      children: [(0, _jsxRuntime.jsx)("path", {
        fill: "#34313F",
        d: "M1311.5,1416.2h314c89.3,0,145.8-49.1,145.8-128c0-74.4-56.5-128-145.8-128h-314c-10.4,0-19.3,8.9-19.3,17.9 v220.2C1293.6,1408.7,1301,1416.2,1311.5,1416.2z M1311.5,1923.6h324.4c99.7,0,159.2-50.6,159.2-139.9 c0-77.4-56.5-139.9-159.2-139.9h-324.4c-10.4,0-19.3,8.9-19.3,17.9v242.6C1293.6,1916.2,1301,1923.6,1311.5,1923.6z"
      }), (0, _jsxRuntime.jsx)("path", {
        fill: "#34313F",
        d: "M2460.3,5.5l-928.6,925.6h151.8c236.6,0,376.5,148.8,376.5,311c0,128-86.3,221.7-178.6,263.4 c-14.9,6-14.9,26.8,1.5,32.7c107.1,41.7,183,153.3,183,284.2c0,184.5-123.5,331.8-363.1,331.8h-657.7c-10.4,0-19.3-8.9-19.3-17.9 v-700.9L6.4,2450.4c-13.4,13.4-4.5,37.2,14.9,37.2h2450.9c8.9,0,16.4-7.4,16.4-16.4V18.9C2493,2.5,2472.2-6.4,2460.3,5.5z"
      })]
    })
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponent);
var _default = ForwardRef;
exports["default"] = _default;
//# sourceMappingURL=BigCommerce.js.map